<template>
  <div class="audit-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('audit.sidebar.auditTitle') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="globalShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'AuditHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            globalShortcuts: [
                {
                    tableTitle: this.$t('component.shortcutsModal.labels.title.auditTitle'),
                    tableElements: [
                        {
                            action: this.$t('component.shortcutsModal.labels.action.searchActionRegistered'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.searchActionRegistered')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.cleanActionRegisteredSearch'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.cleanActionRegisteredSearch')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.exportActionRegisteredSearch'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'E' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.exportActionRegisteredSearch')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.nextElement'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-right', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.nextElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.previousElement'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'far fa-arrow-left', icon: true }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.previousElement')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.closeElementPanel'),
                            shortcuts: [
                                { key: 'Esc' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.closeElementPanel')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
